import { FileNotFoundGitError } from '../errors/file-not-found.git-error';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSReadFileAction extends WorkerAction {
  type: FSAction.ReadFile;
  params: { path: string; cwd?: string };
}

class FSReadFileActionError extends WorkerActionError {}

// This function should only be used by other web-worker functions
// It's a utility function to not have to type-case the type property.
export async function _FSReadFileActionFn(
  params: Omit<WorkerFnParams<FSReadFileAction>, 'params'> & { params: Omit<FSReadFileAction['params'], 'type'> },
) {
  return FSReadFileActionFn(params);
}

export async function FSReadFileActionFn({ fs, params, util }: WorkerFnParams<FSReadFileAction>): Promise<string> {
  const { path, cwd } = params;

  if (!util.itemExistsAt(path)) {
    throw new FileNotFoundGitError(path);
  }

  try {
    const currentCwd = fs.cwd();

    if (cwd) {
      console.debug(`[WasmGit]: setting cwd to "${cwd}"`);
      fs.chdir(cwd);
    }

    const file = fs.readFile(path, { encoding: 'utf8' });

    if (cwd) {
      console.debug(`[WasmGit]: resetting cwd back to "${currentCwd}"`);
      fs.chdir(currentCwd);
    }

    return file;
  } catch (err) {
    throw new FSReadFileActionError(err);
  }
}
